import { FC } from 'react';

import { ButtonLocation } from '../../types/Subscriptions';
import { HeroButtons } from './HeroButtons';
import { PublishedAt } from './PublishedAt';
import { ReadingTime } from './ReadingTime';

interface HeroProps {
  buttonLocation: ButtonLocation;
  handleShare: (platform: string) => void;
  publishedAt: string | null;
  readingTime: number;
  subtitle?: string;
  title: string;
  writtenBy?: string;
}

export const Hero: FC<HeroProps> = ({
  buttonLocation,
  handleShare,
  publishedAt,
  readingTime,
  subtitle,
  title,
  writtenBy,
}) => (
  <header className="flex h-full flex-col items-center justify-center space-y-5 text-center">
    <h1 className="max-w-lg text-md font-bold md:text-lg">{title}</h1>

    <div className="flex max-w-lg flex-col gap-4 md:gap-5">
      {subtitle && <p>{subtitle}</p>}
      <HeroButtons
        buttonLocation={buttonLocation}
        handleShare={handleShare}
        title={title}
      />

      <div className="flex flex-col gap-2 text-neutral-4">
        {writtenBy && <p>{writtenBy}</p>}
        <p>
          <PublishedAt date={publishedAt || ''} />
          <ReadingTime
            minutes={readingTime > 1 ? String(readingTime) : ''}
            separator
          />
        </p>
      </div>
    </div>
  </header>
);
